const ADMIN_PERMISSIONS =
  new Set([
    'administrador',
    'super_administrador'
  ]);

export function normalizePermission(
  value
) {
  return String(value ?? '')
    .trim()
    .toLowerCase();
}

export function normalizePermissions(
  permissions
) {
  if (!Array.isArray(permissions)) {
    return [];
  }

  return [
    ...new Set(
      permissions
        .map(normalizePermission)
        .filter(Boolean)
    )
  ];
}

export function hasAdministrativePermission(
  permissions
) {
  const normalized =
    normalizePermissions(
      permissions
    );

  return normalized.some(
    (permission) =>
      ADMIN_PERMISSIONS.has(
        permission
      )
  );
}

export function permissionGranted(
  permissions,
  requiredPermission
) {
  const required =
    normalizePermission(
      requiredPermission
    );

  if (!required) {
    return false;
  }

  const normalized =
    normalizePermissions(
      permissions
    );

  return (
    normalized.includes(required) ||
    hasAdministrativePermission(
      normalized
    )
  );
}

export {
  ADMIN_PERMISSIONS
};
